import { render, staticRenderFns } from "./HeroImageWithOptionalCta.vue?vue&type=template&id=4ad022fc"
import script from "./HeroImageWithOptionalCta.vue?vue&type=script&lang=js"
export * from "./HeroImageWithOptionalCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeroImageContent: require('/home/runner/work/marketing/marketing/components/HeroImageContent.vue').default})
